
import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ComboHero from '../tokyo-night-combo/components/ComboHero';
import ComboOverview from '../tokyo-night-combo/components/ComboOverview';
import ComboItinerary from '../tokyo-night-combo/components/ComboItinerary';
import ComboGallery from '../tokyo-night-combo/components/ComboGallery';
import ComboPricing from '../tokyo-night-combo/components/ComboPricing';
import ComboFaq from '../tokyo-night-combo/components/ComboFaq';
import ComboFinalCta from '../tokyo-night-combo/components/ComboFinalCta';
import ComboWhatsAppButton from '../tokyo-night-combo/components/ComboWhatsAppButton';

export default function TokyoNightComboJaPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Tokyo Night Combo Experience - 居酒屋＋カラオケ | 東京ローカルコンシェルジュ';
    document.documentElement.lang = 'ja';

    const setMeta = (name: string, content: string, property?: boolean) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', '東京の夜を一晩で体験。地元居酒屋＋カラオケボックスのコンボ体験。地元ガイド同行、4〜5時間、最大4名、¥30,000〜。WhatsAppで簡単予約。');
    setMeta('keywords', '東京ナイトコンボ,居酒屋カラオケ,東京ナイトライフ,Airbnbゲスト東京,東京夜体験,居酒屋カラオケツアー,東京夜遊び');
    setMeta('og:title', 'Tokyo Night Combo Experience - 居酒屋＋カラオケ | 東京ローカルコンシェルジュ', true);
    setMeta('og:description', '東京の夜を一晩で体験。地元居酒屋＋カラオケボックスのコンボ体験。¥30,000〜。', true);
    setMeta('og:type', 'website', true);
    setMeta('og:url', 'https://tokyolocalconcierge.com/tokyo-night-combo-ja', true);
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', 'Tokyo Night Combo Experience - 居酒屋＋カラオケ');
    setMeta('twitter:description', '東京の夜を一晩で体験。地元居酒屋＋カラオケコンボ。¥30,000〜。');
    setMeta('geo.region', 'JP-13');
    setMeta('geo.placename', 'Tokyo');
    setMeta('geo.position', '35.6762;139.6503');
  }, []);

  return (
    <div className="min-h-screen bg-gray-950">
      <Navbar />
      <main>
        <ComboHero lang="ja" />
        <ComboOverview lang="ja" />
        <ComboItinerary lang="ja" />
        <ComboGallery lang="ja" />
        <ComboPricing lang="ja" />
        <ComboFaq lang="ja" />
        <ComboFinalCta lang="ja" />
      </main>
      <Footer />
      <ComboWhatsAppButton lang="ja" />
    </div>
  );
}
